import { render, staticRenderFns } from "./TokensContainer.vue?vue&type=template&id=5fb0fbf2&scoped=true&"
import script from "./TokensContainer.vue?vue&type=script&lang=js&"
export * from "./TokensContainer.vue?vue&type=script&lang=js&"
import style0 from "./TokensContainer.vue?vue&type=style&index=0&id=5fb0fbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0fbf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabs})
